import { render, staticRenderFns } from "./BudgetDetail.vue?vue&type=template&id=0ce03a5f&scoped=true&"
import script from "./BudgetDetail.vue?vue&type=script&lang=js&"
export * from "./BudgetDetail.vue?vue&type=script&lang=js&"
import style0 from "./BudgetDetail.vue?vue&type=style&index=0&id=0ce03a5f&prod&lang=css&"
import style1 from "./BudgetDetail.vue?vue&type=style&index=1&id=0ce03a5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce03a5f",
  null
  
)

export default component.exports